module.exports = __webpack_public_path__ + "static/media/30.9681e4f2.png";